import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return <main className="not-found"><small>Erro 404</small><h1>Página não encontrada.</h1><p>A rota informada ainda não existe na plataforma AEXION.</p><Link className="primary-button" to="/">Voltar para a AEXION</Link></main>
}
